 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		7: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"958b4c57","2":"ec1189df","3":"styles","4":"9ffe8f9b9b98e4d5b52d0330923e65334a2fd892","5":"2be1d05efecff84dc404e020f5bc189c17b39c29","6":"521cc77d25f7c38bed8302cf9adce2315be35df1","9":"component---src-pages-404-js","10":"component---src-pages-advanced-instructions-js","11":"component---src-pages-best-bronze-ball-players-js","12":"component---src-pages-best-gold-ball-players-js","13":"component---src-pages-best-managers-2020-js","14":"component---src-pages-best-managers-js","15":"component---src-pages-best-players-2020-js","16":"component---src-pages-best-players-ball-type-js","17":"component---src-pages-best-silver-ball-players-js","18":"component---src-pages-coins-gp-js","19":"component---src-pages-coming-from-fifa-js","20":"component---src-pages-contact-js","21":"component---src-pages-contract-stamina-renewal-js","22":"component---src-pages-faq-js","23":"component---src-pages-first-steps-js","24":"component---src-pages-game-modes-challenges-js","25":"component---src-pages-gameplay-tips-js","26":"component---src-pages-how-to-get-more-gp-js","27":"component---src-pages-index-js","28":"component---src-pages-legends-js","29":"component---src-pages-manager-2021-js","30":"component---src-pages-manager-js","31":"component---src-pages-manager-upgrades-js","32":"component---src-pages-managers-js","33":"component---src-pages-myclub-tips-tricks-js","34":"component---src-pages-player-attributes-js","35":"component---src-pages-player-form-condition-rating-js","36":"component---src-pages-player-skills-js","37":"component---src-pages-playing-styles-js","38":"component---src-pages-privacy-policy-js","39":"component---src-pages-resources-js","40":"component---src-pages-signing-managers-js","41":"component---src-pages-signing-new-players-agents-js","42":"component---src-pages-signing-new-players-scout-combinations-js","43":"component---src-pages-tip-js","44":"component---src-pages-trading-players-js","45":"component---src-pages-training-players-js"}[chunkId]||chunkId) + "-" + {"0":"b01dfdd94abd2510a475","1":"3fc9ce1c07dcc96a7230","2":"d92345a03408072710c5","3":"474c0340beb1ced255f1","4":"7c3adf20b497a2fb081b","5":"9b6aa9403fa93e1f3b90","6":"89aeff217701d906fd32","9":"a34b30fe4108a3002f82","10":"600b42c7f44616cc32d5","11":"fd0a0f110d71f7f1ec72","12":"7a7f2ce47916bb34bcf0","13":"d59e5d762eb015d7ba9c","14":"bfb616bae3f65c6362c8","15":"40ff59baf62e720f0b26","16":"f226572d5c1a5591bbab","17":"fbff3db3b0e3dc3471fa","18":"c3d35381bd556cf5d87f","19":"f186e29c29588e4b2a58","20":"4f1f2646d698ab0a8a1c","21":"f45793bca4b49cea94f5","22":"85d8e71f7a38411627ec","23":"abfa4d4e49c880a1725d","24":"05e5ae6fe44e8da45728","25":"7f04fd9a4e9c828a6347","26":"d25afd5b1f0f321dd79a","27":"9bdf28b6ff74c7609039","28":"7531146e0dc2c8aa28d6","29":"b93e8e7cd9dfa85456c6","30":"5011f648c29308d53fd4","31":"6496e1536e75b74ae131","32":"5baea27a817a24ec262e","33":"0409c63b4502af76ca6a","34":"30fc2133340aa98b6882","35":"57e0884ad03ae03c6361","36":"4eb1821bf6acad209753","37":"9b3dba8acf51aa58ede6","38":"347520a93f8eaf5d0e5e","39":"53a463b6d3516c3841f7","40":"d8d85b9a5746ff5deae3","41":"f2fab228bb5b43c1cb39","42":"0425a21b74054c819b0d","43":"cfdbd34809fa8f4c5fc8","44":"7ea649cf08f9b9ffdbb5","45":"5587cd0c8e183a458574"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"958b4c57","2":"ec1189df","3":"styles","4":"9ffe8f9b9b98e4d5b52d0330923e65334a2fd892","5":"2be1d05efecff84dc404e020f5bc189c17b39c29","6":"521cc77d25f7c38bed8302cf9adce2315be35df1","9":"component---src-pages-404-js","10":"component---src-pages-advanced-instructions-js","11":"component---src-pages-best-bronze-ball-players-js","12":"component---src-pages-best-gold-ball-players-js","13":"component---src-pages-best-managers-2020-js","14":"component---src-pages-best-managers-js","15":"component---src-pages-best-players-2020-js","16":"component---src-pages-best-players-ball-type-js","17":"component---src-pages-best-silver-ball-players-js","18":"component---src-pages-coins-gp-js","19":"component---src-pages-coming-from-fifa-js","20":"component---src-pages-contact-js","21":"component---src-pages-contract-stamina-renewal-js","22":"component---src-pages-faq-js","23":"component---src-pages-first-steps-js","24":"component---src-pages-game-modes-challenges-js","25":"component---src-pages-gameplay-tips-js","26":"component---src-pages-how-to-get-more-gp-js","27":"component---src-pages-index-js","28":"component---src-pages-legends-js","29":"component---src-pages-manager-2021-js","30":"component---src-pages-manager-js","31":"component---src-pages-manager-upgrades-js","32":"component---src-pages-managers-js","33":"component---src-pages-myclub-tips-tricks-js","34":"component---src-pages-player-attributes-js","35":"component---src-pages-player-form-condition-rating-js","36":"component---src-pages-player-skills-js","37":"component---src-pages-playing-styles-js","38":"component---src-pages-privacy-policy-js","39":"component---src-pages-resources-js","40":"component---src-pages-signing-managers-js","41":"component---src-pages-signing-new-players-agents-js","42":"component---src-pages-signing-new-players-scout-combinations-js","43":"component---src-pages-tip-js","44":"component---src-pages-trading-players-js","45":"component---src-pages-training-players-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"c376c3a339cb67dadd4d","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
